/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Analytics_TitleInputs */

const da_consent_analytics_title = /** @type {(inputs: Consent_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik og feedback`)
};

/** @type {(inputs: Consent_Analytics_TitleInputs) => LocalizedString} */
const en_consent_analytics_title = da_consent_analytics_title;

/**

* @param {Consent_Analytics_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_analytics_title = /** @type {((inputs?: Consent_Analytics_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Analytics_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_analytics_title(inputs)
	return /** @type {LocalizedString} */ ("Statistik og feedback")
});